import { render, staticRenderFns } from "./comboStatistics.vue?vue&type=template&id=72d771aa&scoped=true&"
import script from "./comboStatistics.vue?vue&type=script&lang=js&"
export * from "./comboStatistics.vue?vue&type=script&lang=js&"
import style0 from "./comboStatistics.vue?vue&type=style&index=0&id=72d771aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d771aa",
  null
  
)

export default component.exports